import { Component, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GeneralService } from '../../services/general.service';
import { RequestRestrictedService } from '../../services/request-restricted.service';

@Component({
  selector: 'dialog-restricted-access',
  templateUrl: 'dialog-restricted-access.component.html',
  styleUrls: ['./dialog-restricted-access.component.scss']
})
export class DialogRestrictedAccessComponent {

  request:any = {};

  buttonsDisabled = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialog: MatDialog,
    protected gs: GeneralService,
    protected restrictedService: RequestRestrictedService
  ) { 
    this.request = this.data.data;
  }

  openAd(event, public_idtext){
    this.gs.navigate(['openModal', 'ViewComponentAd', public_idtext]);
  }
  
  openProfile(ev, public_idtext){
    this.gs.openProfile(ev, public_idtext);
  }

  async action(event, action){
    this.buttonsDisabled=true;

    switch(action){
      case 'reject':
        this.restrictedService.reject(this.request, (result) => {
          this.buttonsDisabled=false;
          if(result)
            this.dialog.getDialogById(this.data.modalId).close(result);
        });

      break;
      case 'authorize':        
        this.restrictedService.authorize(this.request, (result) => {
          this.buttonsDisabled=false;
          if(result)
            this.dialog.getDialogById(this.data.modalId).close(result);
        });
        return;
      break;
    }
  }
}